type SectionHeadProps = {
  kicker: string;
  title: string;
  subtitle?: string;
  more?: string;
  moreHref?: string;
  light?: boolean;
};

export default function SectionHead({ kicker, title, subtitle, more, moreHref = '#', light = false }: SectionHeadProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div
          className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold tracking-wide ${
            light ? 'bg-background-50/15 text-secondary-200' : 'bg-secondary-100 text-secondary-800'
          }`}
        >
          <i className="ri-vip-crown-2-line text-sm"></i>
          {kicker}
        </div>
        <h2
          className={`font-heading mt-3 text-2xl font-black md:text-4xl ${
            light ? 'text-background-50' : 'text-foreground-950'
          }`}
        >
          {title}
        </h2>
        {subtitle && (
          <p className={`mt-2 max-w-xl text-sm leading-relaxed md:text-base ${light ? 'text-background-100/80' : 'text-foreground-600'}`}>
            {subtitle}
          </p>
        )}
      </div>
      {more && (
        <a
          href={moreHref}
          className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
            light
              ? 'text-background-100 hover:bg-background-50/10 hover:text-background-50'
              : 'text-primary-700 hover:bg-primary-100'
          }`}
        >
          {more}
          <i className="ri-arrow-right-line"></i>
        </a>
      )}
    </div>
  );
}